// removed by extract-text-webpack-plugin
module.exports = {"popup":"Charts_custom-popup_popup---grni-","key":"Charts_custom-popup_key---2XP2R","value":"Charts_custom-popup_value---2mpSZ","line":"Charts_custom-popup_line---3FrSf"};